<template>
  <div id="myDateShow">
    <div class="title">{{message.id?"修改":"新增"}} 消息</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">信息内容</div>
        <div class="value">
          <el-input  type="textarea"
                      :rows="7"
                      placeholder="请输入内容" v-model="message.content" style="width: 500px"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getMessageById, newVue, updateMessage} from "../../network/message";

  export default {
    name: "MessageInsert",
    data(){
      return{
        message: {},
        messageId: '',
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/systemMessage/list";
      this.common.HeaderLocationTwo.name =  "系统消息管理"
      this.common.HeaderLocationThree.name = "新增or修改系统消息"
      if (this.$route.params.id!=null){
        this.messageId = this.$route.params.id;

        getMessageById(this.messageId).then(res => {
          this.message = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateMessage(this.message).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
